import { render } from "./quiz.vue?vue&type=template&id=57b84ffe&ts=true"
import script from "./quiz.vue?vue&type=script&lang=ts"
export * from "./quiz.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__